import { ITranslations } from 'types/common';
import { RequestsTableFiltersTransFields } from './types';
import en from 'translations/en/requestsTableFilters.json';
import pl from 'translations/pl/requestsTableFilters.json';
import sl from 'translations/sl/requestsTableFilters.json';

export const requestsTableFiltersTranslations: ITranslations<RequestsTableFiltersTransFields> = {
  name: 'requestsTableFilters',
  en,
  pl,
  sl,
};
